import { FlagProvider, IConfig } from "@unleash/proxy-client-react";

import { getEnvironmentVariable } from "../services/env";

const config: IConfig = {
  appName: getEnvironmentVariable("UNLEASH_APP_NAME"),
  clientKey: getEnvironmentVariable("UNLEASH_CLIENT_KEY"),
  environment: getEnvironmentVariable("UNLEASH_ENVIRONMENT"),
  refreshInterval: 15,
  url: getEnvironmentVariable("UNLEASH_PROXY_URL"),
};

const ToggleProvider = ({
  children,
  userId,
}: React.PropsWithChildren<{ userId: string }>) => {
  return (
    <FlagProvider config={{ ...config, context: { userId } }}>
      {children}
    </FlagProvider>
  );
};

export { ToggleProvider };
